import { types as api } from '@mesa-labs/mesa-api';

export const ALL_PARTNERS: api.Partners[] = Object.values(api.Partners)
  .filter(p => !Number.isNaN(parseInt(p.toString(), 10)))
  .filter(p => !!p) as api.Partners[];
